<template>
    <loading
        v-model:active="mostrarLoader"
        color="#001f54"
        loader="dots"
    />

    <section id="tour_booking_submission" class="section_padding">
        <div class="container">
            <Form id="tour_bookking_form_item" @submit="initializePayment" :validation-schema="getValidationSchema">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="tou_booking_form_Wrapper">
                            <div class="booking_tour_form">
                                <h3 class="heading_theme">{{ $t('titles.customer_info') }}</h3>
                                <div class="tour_booking_form_box">
                                    <!-- <form action="!#" id="tour_bookking_form_item"> -->
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <Field name="names" v-slot="{ field, errors, errorMessage }">
                                                        <input type="text" class="form-control bg_input" :placeholder="$t('labels.names')" v-model="datosFacturacion.names" v-bind="field" :class="[{'is-invalid': errors.length>0}]" maxlength="200" @input="handleNamesInput($event, field)" autocomplete="off">
                                                        <span class="text-danger">{{ errorMessage }}</span>
                                                    </Field>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <Field name="email" v-slot="{ field, errors, errorMessage }">
                                                        <input type="text" class="form-control bg_input" :placeholder="$t('labels.email')" v-model="datosFacturacion.email" v-bind="field" :class="[{'is-invalid': errors.length>0}]" maxlength="100" @input="handleEmailInput($event, field)" autocomplete="off">
                                                        <span class="text-danger">{{ errorMessage }}</span>
                                                    </Field>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-group">
<!--                                                    <input type="text" class="form-control bg_input" :placeholder="$t('labels.mobile_number')" v-model="datosFacturacion.mobileNumber" maxlength="50">-->
                                                    <vue-tel-input v-model="datosFacturacion.mobileNumber" v-bind="bindProps" @country-changed="onChangeTelCountry" @input="sanitizePhoneInput">
                                                        <template v-slot:arrow-icon>
                                                            <span>{{ open ? '▲' : '▼' }}</span>
                                                        </template>
                                                    </vue-tel-input>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <select class="form-control form-select bg_input" v-model="datosFacturacion.country">
                                                        <option v-for="pais in paisOptions" :key="pais.value" :value="pais.value">
                                                          {{ pais.text }}
                                                        </option>
                                                      </select>
                                                    <!-- <input type="text" class="form-control bg_input" :placeholder="$t('labels.country')" v-model="datosFacturacion.country" maxlength="100"> -->
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <Field name="id_number" v-slot="{ field, errors, errorMessage }">
                                                        <input type="text" class="form-control bg_input" :placeholder="$t('labels.id_number')" v-model="datosFacturacion.idNumber" v-bind="field" :class="[{'is-invalid': errors.length>0}]" maxlength="15" @input="handleIdNumberInput($event, field)" autocomplete="off">
                                                        <span class="text-danger">{{ errorMessage }}</span>
                                                    </Field>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <input type="text" class="form-control bg_input" :placeholder="$t('labels.state_province')" v-model="datosFacturacion.stateProvince" maxlength="100" autocomplete="off">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="form-group">
                                                    <input type="text" class="form-control bg_input" :placeholder="$t('labels.street_address')" v-model="datosFacturacion.streetAddress" maxlength="500" autocomplete="off">
                                                </div>
                                            </div>
                                        </div>
                                    <!-- </form> -->
                                </div>
                            </div>
                            <div class="booking_tour_form">
                                <h3 class="heading_theme">{{ $t('titles.payment_method') }}</h3>
                                <div class="tour_booking_form_box">
                                    <div class="booking_payment_boxed">
                                        <p>{{ $t('messages.payment_instructions') }}</p>
                                        <br>
                                        <div class="text-center mt-2">
                                            <!-- <a href="#"> -->
                                                <img src="@/assets/img/payment/mastercard-card.png" alt="mastercard card" height="36" class="creditcard-image">
                                                <img src="@/assets/img/payment/visa-card.jpg" alt="visa card" height="36" width="50" class="creditcard-image">
                                                <!-- <img src="@/assets/img/payment/american-card.png" alt="american express card" height="36" class="creditcard-image"> -->
                                                <!-- <img src="@/assets/img/payment/diners-card.png" alt="diners club card" height="36" width="100" class="creditcard-image"> -->
                                            <!-- </a> -->
                                                <p>{{ $t('messages.payment_limit_instructions')}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="tour_details_right_sidebar_wrapper">
                            <div class="tour_detail_right_sidebar">
                                <h3 class="heading_theme">{{ $t('titles.details') }}</h3>

                                <div class="row d-flex justify-content-center">
                                    <div class="col-lg-5">
                                        <select class="form-select form-control" aria-label="Default select example" v-model="tipoViaje">
                                            <option value="ROUNDTRIP">{{ $t('labels.tour_roundtrip') }}</option>
                                            <option value="ENTRANCE">{{ $t('labels.tour_entrance') }}</option>
                                            <option value="DEPARTURE">{{ $t('labels.tour_departure') }}</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-4" v-if="tipoViaje==='ENTRANCE' || tipoViaje==='DEPARTURE'">
                                        <flat-pickr v-model="dateDesde" class="form-control" :placeholder="$t('labels.from_date')" :config="dateConfigDesde"/>
                                    </div>
                                    
                                    <div class="col-lg-3">
                                        <div class="form-group">
                                            <input class="form-control bg_input" style="text-align: right!important;" :placeholder="$t('labels.tickets_number')" type="number" v-model="dynamicTicketModel"  min="1" max="40">
                                        </div>
                                    </div>


                                    <!-- <div class="col-lg-3 select_person_right d-flex justify-content-center align-items-center">
                                        <div class="button-set">
                                            <button type="button" @click="reduceTicket(tipoViaje)">
                                                <i class="fas fa-caret-down" style="font-size:30px;"></i>
                                            </button>

                                            <span style="font-size:40px;"><b>{{ getTicketsNumber(tipoViaje) }}</b></span>

                                            <button type="button" @click="increaseTicket(tipoViaje)">
                                                <i class="fas fa-caret-up" style="font-size:30px;"></i>
                                            </button>
                                        </div>
                                    </div> -->
                                </div>

                                <div class="row d-flex justify-content-center" v-if="tipoViaje==='ROUNDTRIP'">
                                    <div class="form-group col-lg-6 col-md-12">
                                        <flat-pickr v-model="dateDesde" class="form-control" :placeholder="$t('labels.from_date')" :config="dateConfigDesde"/>
                                    </div>
                                    <div class="form-group col-lg-6 col-md-12">
                                        <flat-pickr :key="dateDesde" v-model="dateHasta" class="form-control" :placeholder="$t('labels.to_date')" :config="dateConfigHasta"/>
                                    </div>
                                </div>

                                <div class="tour_details_right_boxed">
                                    <div class="text-center">
                                        <p style="font-size: 14px;">{{ $t('labels.limit_tickets')}}</p>
                                    </div>

                                    <div class="tour_package_details_bar_price pt-0">
                                        <!-- <h5>Price</h5> -->
                                        <div class="d-flex justify-content-between align-items-center select_person_item" v-for="recorrido in filteredRecorridos" :key="recorrido.token">
                                            <div class="tour_package_bar_price">
                                                <div class="select_person_left">
                                                    <div class="d-flex">
                                                        <h3 style="padding-left:0;">{{ recorrido.nombre }}</h3>
                                                        <i v-if="recorrido.descripcion" class="fas fa-info-circle text-muted" style="font-size:15px;" v-tooltip="recorrido.descripcion"></i>
                                                    </div>
                                                    <p>{{ $t('labels.'+recorrido.codigo.toLocaleLowerCase()) }}</p>
                                                </div>
                                            </div>
                                            <div class="select_person_right">
                                                <div class="select_person_right" style="font-size:20px;">
                                                    $ {{ recorrido.precio.toFixed(2) }}
                                                    <b>X {{ getTicketsNumber(recorrido.codigo) }} <i class="fas fa-user"></i></b>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tour_booking_amount_area">
                                            <!-- <ul>
                                                <li>Ticket x {{ ticketsNumber }} <span>$ {{ calculateSubtotal }}</span></li>
                                                <li>Discount <span>-10%</span></li>                                   
                                            </ul> -->
                                            <div class="tour_bokking_subtotal_area" style="padding-bottom: 15px;">
                                                <h6 class="p-0">{{ $t('labels.subtotal') }} <span style="font-size:20px;">$ {{ calculateSubtotal }}</span></h6>
                                                <h6 class="p-0">{{ $t('labels.tax') }} (0%)<span style="font-size:20px;">$ {{ calculateTax }}</span></h6>
                                            </div>
                                            <!-- <div class="coupon_add_area">
                                                <h6><span class="remove_coupon_tour">Remove</span> Coupon code (OFF 5000)
                                                    <span>$5,000.00</span>
                                                </h6>
                                            </div> -->
                                            <div class="total_subtotal_booking" style="border-top: 1px solid #dadada;">
                                                <b><h6>{{ $t('labels.total') }} <span style="font-size:20px;">$ {{ calculateTotal }}</span></h6></b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="booking_tour_form_submit">
                                <Field name="terminos_condiciones" v-slot="{ field, errorMessage }" type="checkbox">
                                    <div class="form-check write_spical_check">
                                        <input class="form-check-input" type="checkbox" id="flexCheckDefaultf1" v-model="datosFacturacion.terminosCondiciones">
                                        <label class="form-check-label" for="flexCheckDefaultf1">
                                            <span class="main_spical_check">
                                                <span>{{ $t('messages.read_accept') }} <a href="https://tickets.lobitogalapagos.com/terms" target="_blank" class="text-primary"><b>{{ $t('messages.terms_conditions') }}</b></a></span>
                                            </span>
                                        </label>
                                    </div>
                                    <span class="text-danger">{{ errorMessage }}</span>
                                </Field>

                                <div class="d-flex justify-content-center mt-4">
                                    <button type="submit" class="btn btn_theme btn_md">{{ $t('labels.to_pay') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </section>
</template>

<script>
import axios from '@/axios'
import { Field, Form } from 'vee-validate';
import { obtenerTipoPersonaFacturacion, snakeToCamel, convertPickerToDate } from "@/assets/utils/actions.js";
import paises from '@/assets/utils/paises.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import flatPickr from "vue-flatpickr-component";

import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

export default {
    name: "TourBookingSubmission",
    components:{
        flatPickr,
        Form,
        Field,
        Loading,
        VueTelInput
    },
    data() {
        return {
            ticketsEntranceNumber: 0,
            ticketsDepartureNumber: 0,
            ticketsRoundtripNumber: 0,
            // ticketsOnewayNumber: 0,

            pricePerOnewayTicket: 5.00,
            pricePerRoundtripTicket: 10.00,
            subtotal: 0.00,
            tax: 0.00,
            total: 0.00,
            taxPercentage: 0.00,
            recorridos: [],
            filteredRecorridos: [],
            tipoViaje: "ENTRANCE",

            dateDesde: '',
            dateHasta: '',

            dateConfigDesde: {
                wrap: true, // set wrap to true only when using 'input-group'
                dateFormat: 'd/m/Y',
                disable: [
                    this.disableDatesDesde
                ]
            },

            dateConfigHasta: {
                wrap: true, // set wrap to true only when using 'input-group'
                dateFormat: 'd/m/Y',
                disable: [
                    this.disableDatesHasta
                ]
            },

            paisOptions: paises.paises,

            datosFacturacion: {
                names: '',
                // firstName: '',
                // lastName: '',
                idNumber: '',
                email: '',
                mobileNumber: '',
                country: 'Ecuador',
                stateProvince: '',
                streetAddress: '',
                terminosCondiciones: false,
                tipoPersona: ''
            },

            paisDefecto: 'Ecuador',

            prefix_dev_reference_producto: '',
            env_mode: '',

            checkoutSchemaV1: {
                names: 'required',
                // first_name: 'required',
                //last_name: 'required',
                id_number: 'required||isCedula||isRuc',
                email: 'required||email',
                // mobile_number: 'required',
                // country: 'required',
                // state_province: 'required',
                // street_address: 'required',
                //terminos_condiciones: 'terminosCondiciones',
            },
            checkoutSchemaV2: {
                names: 'required',
                id_number: 'required',
                email: 'required||email',
            },
            metodoPago: 'TAR',
            mostrarLoader: false,
            limitePrecompraOneway: 7,
            limitePrecompraRoundtrip: 60,

            limiteTicketsEntrance: 40,
            limiteTicketsDeparture: 40,
            limiteTicketsRoundtrip: 40,
            bindProps: {
                mode: "international",
                autoformat: true,
                dropdownOptions: {
                    showDialCode: false,
                    showDialCodeInList: true,
                    showDialCodeInSelection: true,
                    showFlags: true,
                    showSearchBox: true
                },
                inputOptions: {
                    placeholder: 'Tel.',
                    styleClasses: 'form-control bg_input',
                },
                defaultCountry: 'EC'
            },
            inPayment: false
        }
    },

    methods: {
        disableDatesDesde(date) {
            //let limitePrecompra = this.tipoViaje === 'ROUNDTRIP' ? this.limitePrecompraRoundtrip : this.limitePrecompraOneway
            let today = new Date();
            let maxSelectableDate = new Date();
            maxSelectableDate.setDate(today.getDate() + this.limitePrecompraOneway);

            return date < today.setDate(today.getDate() - 1) || date > maxSelectableDate;
        },
        disableDatesHasta(date) {
            //let limitePrecompra = this.tipoViaje === 'ROUNDTRIP' ? this.limitePrecompraRoundtrip : this.limitePrecompraOneway
            if(this.dateDesde === "" || this.dateDesde === null){
                let today = new Date();
                let maxSelectableDate = new Date();
                maxSelectableDate.setDate(today.getDate() + this.limitePrecompraRoundtrip);

                return date < today.setDate(today.getDate() - 1) || date > maxSelectableDate;
            }
            else{
                let fechaReferencia = convertPickerToDate(this.dateDesde)
                let maxSelectableDate = new Date(fechaReferencia);
                maxSelectableDate.setDate(fechaReferencia.getDate() + this.limitePrecompraRoundtrip);

                return date < fechaReferencia.setDate(fechaReferencia.getDate()) || date > maxSelectableDate;
            }
        },
        increaseTicket(type) {
            let ticketType = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
            const property = `tickets${ticketType}Number`
            const propertyLimiteTickets = `limiteTickets${ticketType}`
            if (this[property] < this[propertyLimiteTickets]) {
                this[property]++;
            }
        },
        reduceTicket(type){
            let ticketType = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
            const property = `tickets${ticketType}Number`
            if (this[property] > 0) {
                this[property]--;
            }
        },
        getRecorridos(){
            this.openLoadingInDiv()
            axios
            .post("api", {
            query: `query recorridos{
                      recorridos{
                          recorridos{
                              token
                              nombre
                              descripcion
                              codigo
                              precio
                              tipo
                          }
                          limitePrecompra
                          status
                          message
                      }
                  }`
            })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.recorridos.status === 'success') {
                        this.recorridos = response.data.data.recorridos.recorridos
                        this.getAmountTicketsFromStorage()
                        let component = this
                        this.filteredRecorridos = this.recorridos.filter(item => item.tipo === component.tipoViaje)
                        this.limitePrecompra = response.data.data.recorridos.limitePrecompra
                        this.getTravelTypeFromStorage()
                        this.getDatesFromStorage()
                        this.getAmountTicketsFromStorage()
                    } else {
                        this.showErrorAlert(response.data.data.recorridos.message)
                    }
                }
                this.closeLoadingInDiv()
            })
        },
        getTicketsNumber(type){
            if(type){
                let ticketType = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
                const property = `tickets${ticketType}Number`
                return this[property]
            }
            return 0
        },
        setTicketsNumber(val) {
            const ticketType = this.tipoViaje.charAt(0).toUpperCase() + this.tipoViaje.slice(1).toLowerCase();
            const property = `tickets${ticketType}Number`;
            
            if (Number.isInteger(val) && val >= 0 && val <= this.limiteTicketsRoundtrip) {
                this[property] = val;
            }
            else{
                this[property] = 1;
            }
        },
        obtenerConfigPaymentez(){
            this.openLoadingInDiv()
            axios
            .post("api", {
            query: `query getConfigPaymentez{
                      getConfigPaymentez{
                          data{
                              prefixDevReferenceProducto
                              envMode
                          }
                          status
                          message
                      }
                  }`
            })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.getConfigPaymentez.status === 'success') {
                        this.prefix_dev_reference_producto = response.data.data.getConfigPaymentez.data.prefixDevReferenceProducto
                        this.env_mode = response.data.data.getConfigPaymentez.data.envMode
                    } else {
                        this.showErrorAlert(response.data.data.getConfigPaymentez.message)
                    }
                }
                this.closeLoadingInDiv()
            })
        },
        inicializarPaymentezPaycard(){
            let thisComponent = this
            this.paymentCheckout = new PaymentCheckout.modal({
                // client_app_code: thisComponent.credenciales_paymentez.client_app_code, // Client Credentials
                // client_app_key: thisComponent.credenciales_paymentez.client_app_key, // Client Credentials
                locale: 'es', // User's preferred language (es, en, pt). English will be used by default.
                env_mode: 'prod', // `prod`, `stg`, `local` to change environment. Default is `stg`

                onResponse: async function (response) { // The callback to invoke when the Checkout process is completed
                    console.log("++++++++++++++++++++++++++++++++++++++++++")
                    console.log(response)
                    console.log("++++++++++++++++++++++++++++++++++++++++++")
                    axios
                    .post("api", {
                    query: `mutation guardarLogPago($dataPago: String!){
                                guardarLogPago(dataPago:$dataPago){
                                    status
                                    message
                                }
                            }`,
                        variables: {
                            dataPago: JSON.stringify(response),
                        },
                    })

                    if(response.transaction.status_detail == 3){
                        thisComponent.openLoadingInDiv()
                        await thisComponent.procesarPagoCarrito(response)
                    }
                    else{
                        thisComponent.showErrorAlert(thisComponent.$t('messages.payment_error') + ' ERROR: ' + String(response.transaction.current_status) + '. ' + String(response.transaction.message))
                    }
                },
                onClose(){
                    console.log("evento close paymentez modal")
                }
            })
        },
        validarPagoCarrito(){
            this.mostrarLoader = true;
            axios
            .post("api", {
                query: `mutation validarPagoCarrito($tipoViaje: String!, $fechaDesde: String, $fechaHasta: String, $cantidadTickets: Int!, $locale: String!){
                    validarPagoCarrito(tipoViaje:$tipoViaje, fechaDesde:$fechaDesde, fechaHasta:$fechaHasta, cantidadTickets:$cantidadTickets, locale:$locale){
                        validacion
                        status
                        message
                    }
                }`,
                variables: {
                    tipoViaje: this.tipoViaje,
                    fechaDesde: this.dateDesde,
                    fechaHasta: this.dateHasta,
                    cantidadTickets: this.getTicketsNumber(this.tipoViaje),
                    locale: this.$i18n.locale
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.validarPagoCarrito.status === 'success' && response.data.data.validarPagoCarrito.validacion) {
                        // Proceed with payment
                        this.mostrarLoader = true;
                        this.obtenerTipoPersona();
                        this.makeCheckoutPaymentez();
                    } else {
                        this.mostrarLoader = false;
                        this.showErrorAlert(response.data.data.validarPagoCarrito.message)
                    }
                }
            })
        },
        procesarPagoCarrito(datosPago){
            // this.openLoadingInDiv()

            let carrito = this.getCarritoCheckout()

            const { transaction, card } = datosPago;
            const newDatosPago = {
                transaction: snakeToCamel(transaction),
                card: snakeToCamel(card)
            };

            console.log(newDatosPago)

            // const filteredNewDatosPago = { transaction, card };

            // console.log("filtered nes datos pago")
            // console.log(filteredNewDatosPago)

            let datosOrden = {
                total: this.calculateTotal,
                subtotal: this.calculateSubtotal,
                impuestos: this.calculateTax,
                detalles: carrito
            }

                axios
                .post("api", {
                query: `mutation procesarPagoCarrito($datosFacturacion: DatosFacturacionInput!, $datosOrden: DatosOrdenInput!, $datosPago: DatosPagoInput!, $metodoPago: String!, $locale: String!, $fechaDesde:String, $fechaHasta:String){
                            procesarPagoCarrito(datosFacturacion:$datosFacturacion, datosOrden:$datosOrden, datosPago:$datosPago, metodoPago:$metodoPago, locale:$locale, fechaDesde:$fechaDesde, fechaHasta:$fechaHasta){
                                status
                                message
                            }
                        }`,
                    variables: {
                        datosFacturacion: this.datosFacturacion,
                        datosOrden: datosOrden,
                        datosPago: newDatosPago,
                        metodoPago: this.metodoPago,
                        locale: this.$i18n.locale,
                        fechaDesde: this.dateDesde,
                        fechaHasta: this.dateHasta
                    },
                })
                .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.procesarPagoCarrito.status === 'success') {
                        this.$swal({
                            title: this.$t('messages.finished_payment'),
                            text: this.$t('messages.tickets_sent'),
                            icon: 'success',
                            confirmButtonColor: '#001F54',
                            confirmButtonText: this.$t('labels.accept'),
                        }).then(result => {
                            this.clearAmountTickets()
                            this.clearDates()
                            this.clearTravelType()
                            this.$router.push("tour-details")
                        })
                    } else {
                        this.showErrorAlert(response.data.data.procesarPagoCarrito.message)
                    }
                }
                this.closeLoadingInDiv()
            })
        },
        async initializePayment() {
            // Check if tickets are selected
            if (this.calculateAmountTickets <= 0) {
                this.showErrorAlert(this.$t('messages.select_ticket_error'));
                return;
            }
            // Check terms and conditions
            if (!this.datosFacturacion.terminosCondiciones) {
                this.showErrorAlert(this.$t('messages.terms_conditions_error'));
                return;
            }

            // Show confirmation dialog
            this.$swal({
                title: this.$t('messages.complete_checkout'),
                text: this.$t('messages.sure_complete_purchase'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#001F54',
                confirmButtonText: this.$t('labels.accept'),
                cancelButtonText: this.$t('labels.cancel'),
            }).then(async result => {
                if (!result.value) return; // Exit if user cancels

                // Validate dates based on trip type
                if (this.hasInvalidDates()) {
                    return; // Exit if dates are invalid
                }

                this.validarPagoCarrito()
                // console.log(this.validarPagoCarrito())
                // let validacionPago = await this.validarPagoCarrito()
                // console.log(validacionPago)
                // if (!validacionPago) {
                //     console.log("entra en return de validar carrito")
                //     return;
                // }
            });
        },
        makeCheckoutPaymentez(){
            this.openLoadingInDiv()

            let amount = parseFloat(this.calculateTotal)
            let description = 'Pago por compra de tickets online'
            let vat = parseFloat(this.calculateTax)
            let taxable_amount = parseFloat(this.calculateSubtotal)
            let tax_percentage = parseFloat(String(this.taxPercentage))

            let sep = '|';
            let dev_reference = [
                this.tipoViaje, //10
                String(this.calculateTotal), //7
                // String(this.calculateSubtotal), //7
                // String(this.calculateTax), //4
                String(this.calculateAmountTickets), //3
                String(this.dateDesde), //10
                String(this.dateHasta), //10
                // this.datosFacturacion.names.substring(0, 15), //15
                // this.datosFacturacion.email.substring(0, 15), //15
                this.datosFacturacion.mobileNumber.substring(0, 20), //15
                this.datosFacturacion.country.substring(0, 10), //10
                String(this.datosFacturacion.idNumber).substring(0, 15), //13
                this.datosFacturacion.tipoPersona, //1
                this.$i18n.locale //2
            ].map(String).join(sep);

            // let dev_reference = this.tipoViaje + '-' + String(this.calculateAmountTickets) + '-' + String(this.dateDesde) + '-' + String(this.dateHasta) + '-' + String(this.datosFacturacion.names) + '-' + String(this.datosFacturacion.email) + '-' + String(this.datosFacturacion.mobileNumber) + '-' + String(this.datosFacturacion.country) + '-' + String(this.datosFacturacion.idNumber) + '-' + String(this.datosFacturacion.tipoPersona) + '/' + String(this.$i18n.locale)
            
            let client_id = this.datosFacturacion.names.substring(0, 50)
            let client_email = this.datosFacturacion.email.substring(0, 50)

            axios
            .post("api", {
            query: `mutation generarCheckoutReference($vat: Float!, $taxableAmount: Float!, $taxPercentage: Float!, $devReference: String!, $description: String!, $amount: Float!, $id: String!, $email: String!, $country: String!, $locale: String!){
                        generarCheckoutReference(vat:$vat, taxableAmount:$taxableAmount, taxPercentage:$taxPercentage, devReference:$devReference, description:$description, amount:$amount, id:$id, email:$email, country:$country, locale:$locale){
                            data{
                                reference
                            }
                            status
                            message
                        }
                    }`,
                variables: {
                    vat: vat,
                    taxableAmount: taxable_amount,
                    taxPercentage: tax_percentage,
                    devReference: dev_reference,
                    description: description,
                    amount: amount,
                    id: client_id,
                    email: client_email,
                    country: this.datosFacturacion.country,
                    locale: this.$i18n.locale
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.data.generarCheckoutReference.status === 'success') {
                        this.paymentCheckout.open({
                            reference: response.data.data.generarCheckoutReference.data.reference // reference received for Payment Gateway
                        });
                    } else {
                        this.showErrorAlert(response.data.data.generarCheckoutReference.message)
                    }
                }
                this.closeLoadingInDiv()
            })
        },
        getCarritoCheckout(){
            let carrito = []
            for(let recorrido of this.filteredRecorridos){
                let ticketType = recorrido.codigo.charAt(0).toUpperCase() + recorrido.codigo.slice(1).toLowerCase()
                let property = `tickets${ticketType}Number`

                // console.log(recorrido.nombre)
                // console.log("cantidad de ticket es---->")
                // console.log(this[property])
                if(this[property] > 0){
                    let detalle_orden = {
                        nombre: recorrido.nombre,
                        token: recorrido.token,
                        codigo: recorrido.codigo,
                        precio: recorrido.precio,
                        cantidad: this[property]
                    }
                    carrito.push(detalle_orden)
                }
            }

            return carrito
        },
        obtenerTipoPersona(){
          const cedulaRuc = this.datosFacturacion.idNumber
          this.datosFacturacion.tipoPersona = obtenerTipoPersonaFacturacion(cedulaRuc)
        },
        getAmountTicketsFromStorage(){
            for(let recorrido of this.recorridos){
                let ticketType = recorrido.codigo.charAt(0).toUpperCase() + recorrido.codigo.slice(1).toLowerCase()
                const property = `tickets${ticketType}Number`
                if(localStorage.getItem(`ticket${ticketType}Number`) !== null && localStorage.getItem(`ticket${ticketType}Number`) !== ''){
                    this[property] = parseInt(localStorage.getItem(`ticket${ticketType}Number`))
                }
                else{
                    this[property] = 0
                }
            }
            this.setAmountTicketsToStorage()
        },
        setAmountTicketsToStorage(){
            for(let recorrido of this.recorridos){
                let ticketType = recorrido.codigo.charAt(0).toUpperCase() + recorrido.codigo.slice(1).toLowerCase()
                const property = `tickets${ticketType}Number`
                localStorage.setItem(`ticket${ticketType}Number`, this[property])
            }
        },
        clearAmountTickets(){
            for(let recorrido of this.recorridos){
                let ticketType = recorrido.codigo.charAt(0).toUpperCase() + recorrido.codigo.slice(1).toLowerCase()
                const property = `tickets${ticketType}Number`
                this[property] = 0
            }
            this.setAmountTicketsToStorage()
        },
        getDatesFromStorage(){
            this.dateDesde = localStorage.getItem('dateFrom')
            this.dateHasta = localStorage.getItem('dateTo')

            this.setDatesToStorage()
        },
        setDatesToStorage(){
            localStorage.setItem('dateFrom', this.dateDesde)
            localStorage.setItem('dateTo', this.dateHasta)
        },
        clearDates(){
            this.dateDesde = ''
            this.dateHasta = ''
            this.setDatesToStorage()
        },
        getTravelTypeFromStorage(){
            if(localStorage.getItem('travelType') !== null && localStorage.getItem('travelType') !== ''){
                this.tipoViaje = localStorage.getItem('travelType')
            }

            this.setTravelTypeToStorage()
        },
        setTravelTypeToStorage(){
            localStorage.setItem('travelType', this.tipoViaje)
        },
        clearTravelType(){
            this.tipoViaje = "ROUNDTRIP"
            this.setTravelTypeToStorage()
        },
        openLoadingInDiv(){
            this.mostrarLoader = true
        },
        closeLoadingInDiv(){
            this.mostrarLoader = false
        },
        showErrorAlert(message) {
            this.$swal({
                title: 'Error',
                text: message,
                icon: 'error',
                confirmButtonColor: '#001F54',
            });
        },
        hasInvalidDates() {
            if (this.tipoViaje === 'ROUNDTRIP' && (!this.dateDesde || !this.dateHasta)) {
                this.showErrorAlert(this.$t('messages.from_date_error'));
                return true;
            }

            if ((this.tipoViaje === 'ENTRANCE' || this.tipoViaje === 'DEPARTURE') && !this.dateDesde) {
                this.showErrorAlert(this.$t('messages.roundtrip_date_error'));
                return true;
            }

            return false;
        },
        onChangeTelCountry(object){
            // console.log(object)
            this.datosFacturacion.country = object.name
        },
        handleBeforeUnload(event) {
            const message = "You cannot close the page until the payment is complete";
            event.preventDefault();
            event.returnValue = message; // Necesario para que algunos navegadores muestren alerta
            return message;
        },
        handleEmailInput(event, field) {
            const sanitizedValue = event.target.value.replace(/\|/g, '');
            this.datosFacturacion.email = sanitizedValue;
            field.value = sanitizedValue; // sincroniza con vee-validate
        },
        handleNamesInput(event, field) {
            // Solo letras sin tildes, "ñ", y espacios
            const sanitizedValue = event.target.value.replace(/[^a-zA-ZñÑ\s]/g, '');
            this.datosFacturacion.names = sanitizedValue;
            field.value = sanitizedValue;
        },
        handleIdNumberInput(event, field) {
            // Solo letras sin tildes, números
            const sanitizedValue = event.target.value.replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s/g, '');
            this.datosFacturacion.idNumber = sanitizedValue;
            field.value = sanitizedValue;
        },
        sanitizePhoneInput(event) {
            // Remove the '|' character from the input
            this.datosFacturacion.mobileNumber = this.datosFacturacion.mobileNumber.replace(/\|/g, '');
        },
    },
    computed: {
        calculateAmountTickets(){
            let total = 0
            total = this.ticketsRoundtripNumber + this.ticketsEntranceNumber + this.ticketsDepartureNumber

            return total
        },
        calculateSubtotal(){
            let subtotal = 0.00
            subtotal = (this.ticketsRoundtripNumber * this.pricePerRoundtripTicket) + (this.ticketsEntranceNumber + this.ticketsDepartureNumber) * this.pricePerOnewayTicket

            return subtotal.toFixed(2)
        },
        calculateTax(){
            let tax = 0.00
            tax = this.taxPercentage * this.calculateSubtotal

            return tax.toFixed(2)
        },
        calculateTotal(){
            let total = 0.00
            total = parseFloat(this.calculateSubtotal) + parseFloat(this.calculateTax)

            return total.toFixed(2)
        },
        getValidationSchema(){
            if(this.datosFacturacion.country===this.paisDefecto){
                return this.checkoutSchemaV1
            }
            else {
                return this.checkoutSchemaV2
            }
        },

        dynamicTicketModel: {
            get() {
                return this.getTicketsNumber(this.tipoViaje)
            },
            set(val) {
                return this.setTicketsNumber(val)
            }
        }
    },
    watch: {
        tipoViaje(newValue, oldValue){
            // console.log(newValue)
            // console.log(this.recorridos)
            this.filteredRecorridos = this.recorridos.filter(item => item.tipo === newValue)
            // console.log(this.filteredRecorridos)
            let ticketType = oldValue.charAt(0).toUpperCase() + oldValue.slice(1).toLowerCase()
            const property = `tickets${ticketType}Number`
            this[property] = 0
        }
    },
    mounted(){
        this.getRecorridos()

        // this.getAmountTicketsFromStorage()

        this.obtenerConfigPaymentez()
        this.inicializarPaymentezPaycard()
    }
};
</script>

<style>
    .creditcard-image{
        height: 36px!important;
        margin-right: 7px;
    }
</style>